import FunctionHelper from "./FunctionHelper";

/**
 * The PaperHelper bundles useful static functions for paper formats
 */
export default class NumberHelper {
	/**
	 * Format a number as string
	 */
	public static formatString(value: number, decimals?: number): string {
		return this.format(value, decimals) + '';
	}

	public static format(value: number, decimals?: number): number {
		let pow = Math.pow(10, !FunctionHelper.exists(decimals) ? 2 : decimals!);
		return (Math.ceil(value * pow) / pow);
	}

	/**
	 * parse a string to integer
	 */
	public static parseInt(value: string | number, options?: { min?: number, max?: number }): number {
		let result: number = (typeof value === "number") ? value : parseInt(value);
		result = Math.floor(result);

		if (FunctionHelper.exists(options?.min) && result < options!.min!) {
			return options!.min!;
		} else if (FunctionHelper.exists(options?.max) && result > options!.max!) {
			return options!.max!;
		}

		return result;
	}

	public static limit(value: number, min: number, max: number) {
		return Math.max(Math.min(value, max), min);
	}
}